module.exports = __webpack_public_path__ + "static/media/ico-dash.f2089aaf.svg";